import React from "react";
import cn from "./helpers/cn";

export interface ListContextValue {
  dense: boolean;
  disableGutters: boolean;
}

export const ListContext = React.createContext<ListContextValue>({
  dense: false,
  disableGutters: false,
});

interface ListProps extends React.HTMLAttributes<HTMLUListElement> {
  component?: React.ElementType;
  dense?: boolean;
  disablePadding?: boolean;
  subheader?: React.ReactNode;
  children?: React.ReactNode;
}

const List = React.forwardRef<HTMLUListElement, ListProps>((props, ref) => {
  const {
    className,
    component: Component = "ul",
    dense = false,
    disablePadding = false,
    subheader,
    children,
    ...other
  } = props;

  const ctx = React.useMemo<ListContextValue>(() => ({
    dense,
    disableGutters: false,
  }), [dense]);

  return (
    <ListContext.Provider value={ctx}>
      <Component
        ref={ref}
        className={cn(
          // MUI v4: padding 8px 0, lista sem bullet/margem.
          "relative list-none m-0",
          !disablePadding && "py-2",
          // Reserva espaço para subheader sticky (MUI v4 default).
          subheader && "pt-0",
          className
        )}
        {...other}
      >
        {subheader}
        {children}
      </Component>
    </ListContext.Provider>
  );
});

List.displayName = "List";

export default List;
